import revealElement from '../utilities/revealElement'

const backToTop = () => revealElement('.c-hero', '.js-back-to-top', true)

export default backToTop
